import application from "stimulus_application";
import IntroController from "./intro_controller";
import "./intro.css";

application.register("intro", IntroController);
